import React from 'react';
import NFTMarketPlace from '../sectionBlocks/NFTMarket';
import Footer from "../sectionBlocks/Footer";
import {Helmet} from "react-helmet";

function VideosPeople({data, loading, error, localData}) {
  return (
    <>
      <Helmet>
        <title>PopBelly NFT VidEOs · People</title>
      </Helmet>
      <div style={{minHeight: "200px"}}/>
      <NFTMarketPlace 
        displayCollectionName = {``} 
        collectionName = {`People NFT PopBeLLy ANIMATED Collection`} 
        displayPagination = {``} 
        displayLink = {`dn`} 
        linkAddress = {``} 
        linkTitle = {``} 
        fetchingCardsRule = {({meta}) => meta.content[1] && meta.attributes[0].value === "People"}
        sliceStart = {0}
        loading = {loading} 
        error = {error} 
        data = {data} 
        localData = {localData}
      />
      <Footer/>
    </>
  );
}

export default VideosPeople;
